import { useState, useEffect } from "react";
import { baseUrl, getRequestOptions, handleAuth } from "../../../common/cookie";
import Loader from "../../../common/loader";
import { CloseIcon, CopyableCell } from "../../../common/functions";
import * as XLSX from "xlsx";

let tableTitlesTrades: string[] = [
  "B/S",
  "BB Ticker",
  "Location",
  "Trade Date",
  "Trade Time",
  "Settle Date",
  "Price",
  "Notional Amount",
  "Settlement Amount",
  "Accrued Interest",
  "Counter Party",
  "Triada Trade Id",
  "Updated Notional",
  "Currency",
];

function ViewTradeHistory(props: any) {
  let [trades, setTrades] = useState<any>(null);
  let [loading, setLoading] = useState(true);
  let [error, setError] = useState<string | null>(null);

  let positionInfo = props.positionInfo;
  let [displayInfo, setDisplayInfo] = useState({ isin: "", location: "", bbTicker: "" });
  let isin = "";
  let location = "";
  let bbTicker = "";

  if (positionInfo && typeof positionInfo === "object" && !Array.isArray(positionInfo)) {
    isin = positionInfo["ISIN"] || "";
    location = positionInfo["Location"] || "";
    bbTicker = positionInfo["BB Ticker"] || "";
  }

  let selectedDate = props.date || "";

  useEffect(() => {
    if (!isin && !location && !bbTicker) {
      setLoading(false);
      setError("Please provide ISIN, Location, or BB Ticker to search");
      return;
    }

    setLoading(true);
    setError(null);
    let url = baseUrl + `search-trade-history?isin=${encodeURIComponent(isin)}&location=${encodeURIComponent(location)}&bbTicker=${encodeURIComponent(bbTicker)}&date=${encodeURIComponent(selectedDate)}`;
    
    fetch(url, getRequestOptions)
      .then((res) => {
        handleAuth(res.status);
        return res.json();
      })
      .then((data) => {
        if (data.error) {
          setError(data.error);
          setTrades([]);
        } else {
          setTrades(data.trades || []);
          // Update display info from found position
          if (data.position) {
            setDisplayInfo({
              isin: data.position["ISIN"] || isin,
              location: data.position["Location"] || location,
              bbTicker: data.position["BB Ticker"] || bbTicker
            });
          } else {
            setDisplayInfo({ isin, location, bbTicker });
          }
        }
        setLoading(false);
      })
      .catch((err) => {
        let msg: string = err.message || "An error occurred";
        if (msg === "Load failed" || msg === "Failed to fetch" || msg === "NetworkError when attempting to fetch resource.") {
          msg = "Cannot connect to server. Please ensure the backend is running on port 8080.";
        }
        setError(msg);
        setTrades([]);
        setLoading(false);
      });
  }, [isin, location, bbTicker, selectedDate]);

  function downloadCSV() {
    let table = document.getElementById("trade-history-table");
    let wb = XLSX.utils.table_to_book(table, { sheet: "Trade History" });
    let fileName = `trade_history_${displayInfo.bbTicker || bbTicker}_${displayInfo.location || location}.xlsx`;
    XLSX.writeFile(wb, fileName);
  }

  if (loading) {
    return (
      <div className="edit-info-container-1">
        <Loader />
      </div>
    );
  }

  return (
    <div className="edit-info-container-1">
      <div onClick={(event) => props.setTradeHistoryCardDisplay("none")}>
        <CloseIcon classNameInput="rlzd-close-icon" />
      </div>

      <div className="trades-inputs position-container rlzd-trades-info-container-2 rlzd-trades-card">
        <div className="rlzd-trades-titles" style={{ borderBottom: "1px solid #ddd", paddingBottom: "10px", marginBottom: "10px" }}>
          <h4 style={{ margin: 0, fontWeight: 600 }}>Trade History</h4>
          <p style={{ margin: "5px 0 0 0", color: "#555", fontSize: "14px" }}>
            {displayInfo.bbTicker || bbTicker} | {displayInfo.isin || isin} | {displayInfo.location || location}
          </p>
        </div>

        {error && (
          <div style={{ padding: "10px 15px", backgroundColor: "#ffebee", borderRadius: "4px", marginBottom: "10px", color: "#c62828", fontSize: "14px" }}>
            {error}
          </div>
        )}

        <div
          style={{
            width: "100%",
          }}
          className="table-container-custom"
        >
          {trades && trades.length > 0 ? (
            <>
              <p style={{ marginBottom: "10px", color: "#666" }}>Total trades: {trades.length}</p>
              <table
                id="trade-history-table"
                style={{
                  width: "100%",
                }}
                className="table table-hover table-portfolio table-striped table-trades"
              >
                <tbody>
                  <tr className="sticky-top table-header">
                    {tableTitlesTrades.map((title: string, index: number) => (
                      <td key={index}>{title}</td>
                    ))}
                  </tr>

                  {trades.map((trade: any, index: number) => (
                    <tr key={index} className="table-body">
                      {tableTitlesTrades.map((title: string, idx: number) => (
                        <CopyableCell
                          key={idx}
                          text={
                            trade[title] !== undefined && trade[title] !== null
                              ? isFinite(trade[title])
                                ? trade[title].toLocaleString()
                                : trade[title]
                              : ""
                          }
                        />
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <button id="download-btn" onClick={downloadCSV} className="btn upload-btn" style={{ marginTop: "10px" }}>
                Download CSV
              </button>
            </>
          ) : (
            <div style={{ padding: "30px", textAlign: "center", color: "#888", fontSize: "14px" }}>
              No trades found for this position.
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default ViewTradeHistory;
